module.exports = __webpack_public_path__ + "img/DE05911.0e534f56.png";